import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  max-width: 80%;\n  margin-bottom: 10px;\n  top: 50px;\n  position: absolute;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  overflow-y: auto;\n  margin-top: 60px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex-direction: column;\n\n  @media screen and (max-width: ", "px) {\n    min-width: 295px;\n    margin-top: 50px;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  background-color: #ff6a00;\n  border-radius: 50%;\n  color: #fff;\n  display: inline-block;\n  height: 20px;\n  left: -5px;\n  line-height: 20px;\n  position: absolute;\n  top: -5px;\n  width: 20px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  justify-content: flex-start;\n\n  @media screen and (min-width: ", "px) {\n    min-height: 50vh;\n    min-width: 600px;\n  }\n\n  @media screen and (max-width: ", "px) {\n    height: 500px;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: fixed;\n  right: 10px;\n  bottom: 10px;\n  width: 50px;\n  height: 50px;\n  border-radius: 100%;\n  border: 1px solid transparent;\n  background-color: #18bbf7;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useState, useEffect, useMemo } from 'react';
import { AcornsIcon } from '@acorns/icons';
import { styled, CloseButtonPosition, Modal, useSessionStorage, PillNavigation } from '@acorns/web-components';
import axios from 'axios';
import { style } from '../../../theme';
import { PromptPortal } from '../../../utils/providers/prompt';
import FeatureToggleList from './FeatureToggle/FeatureToggleList';
import { BuildList } from './BuildList';
var SettingsButton = styled.button(_templateObject());
var StyledModal = styled(Modal)(_templateObject2(), style(function (theme) {
  return theme.breakpoints.sm + 1;
}), style(function (theme) {
  return theme.breakpoints.sm;
}));
var AlertBadge = styled.div(_templateObject3());
var OptionsContainer = styled.div(_templateObject4(), style(function (theme) {
  return theme.breakpoints.sm;
}));
var developerMenuItems = ['BUILD_SELECTOR', 'FEATURE_TOGGLE'];
var StyledPill = styled(PillNavigation)(_templateObject5());

var DeveloperMenuSelector = function DeveloperMenuSelector(_ref) {
  var handleMenuChange = _ref.handleMenuChange;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      selectedIndex = _useState2[0],
      setSelectedIndex = _useState2[1];

  var options = [{
    id: 0,
    text: 'Build Selector'
  }, {
    id: 1,
    text: 'Feature Toggle'
  }];

  var handleSelect = function handleSelect(index) {
    handleMenuChange(index);
    setSelectedIndex(index);
  };

  return /*#__PURE__*/React.createElement(StyledPill, {
    options: options,
    selectedIndex: selectedIndex,
    onSelect: function onSelect(index) {
      return handleSelect(index);
    },
    selectedLabelColor: "#74C947"
  });
};

var BuildSelector = function BuildSelector(_ref2) {
  var projectNames = _ref2.projectNames,
      featureNames = _ref2.featureNames,
      handleEnvToggle = _ref2.handleEnvToggle,
      optimizelyEnv = _ref2.optimizelyEnv;

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isOpen = _useState4[0],
      setIsOpen = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      menuIndex = _useState6[0],
      setMenuIndex = _useState6[1];

  var _useSessionStorage = useSessionStorage(),
      getItem = _useSessionStorage.getItem;

  var handleClose = function handleClose() {
    return setIsOpen(false);
  };

  var handleOpen = function handleOpen() {
    setIsOpen(true);
    setMenuIndex(0);
  };

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      builds = _useState8[0],
      setBuilds = _useState8[1];

  var _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      customBuilds = _useState10[0],
      setCustomBuilds = _useState10[1];

  var buildOptions = useMemo(function () {
    return builds.map(function (_ref3) {
      var projectName = _ref3.projectName,
          builds = _ref3.builds,
          startKey = _ref3.startKey;
      return {
        projectName: projectName,
        startKey: startKey,
        options: builds.map(function (build) {
          return {
            label: build.name,
            value: build.name,
            subtext: build.branch || ''
          };
        })
      };
    });
  }, [builds]);

  var initCustomBuilds = function initCustomBuilds() {
    setCustomBuilds(buildOptions.filter(function (_ref4) {
      var _getItem;

      var projectName = _ref4.projectName;
      return ((_getItem = getItem("".concat(projectName, "_builds"))) === null || _getItem === void 0 ? void 0 : _getItem.trim()) !== "".concat(projectName, ".js");
    }).map(function (_ref5) {
      var projectName = _ref5.projectName;
      return projectName;
    }));
  };

  var sortedFeatureNames = featureNames.sort(function (a, b) {
    return a.localeCompare(b);
  });
  useEffect(function () {
    initCustomBuilds();
  }, [buildOptions]);
  useEffect(function () {
    var buildRequests = projectNames.map(function (projectName) {
      return axios.get("".concat(process.env.MICRO_FRONTEND_LAMBDA, "/").concat(process.env.BUILD_ENV, "/listbuilds?project=").concat(projectName, "&limit=20"));
    });
    axios.all(buildRequests).then(function (response) {
      response.map(function (builds) {
        var _builds$data, _builds$data$Items, _builds$data$Items$, _builds$data2;

        var projectName = (_builds$data = builds.data) === null || _builds$data === void 0 ? void 0 : (_builds$data$Items = _builds$data.Items) === null || _builds$data$Items === void 0 ? void 0 : (_builds$data$Items$ = _builds$data$Items[0]) === null || _builds$data$Items$ === void 0 ? void 0 : _builds$data$Items$.project;
        var lastEvaluatedKey = (_builds$data2 = builds.data) === null || _builds$data2 === void 0 ? void 0 : _builds$data2.LastEvaluatedKey;

        if (projectName) {
          setBuilds(function (prevBuild) {
            return [].concat(_toConsumableArray(prevBuild), [{
              startKey: lastEvaluatedKey === null || lastEvaluatedKey === void 0 ? void 0 : lastEvaluatedKey.timestamp,
              projectName: projectName,
              builds: builds.data.Items
            }]);
          });
        }
      });
    })["catch"](function (error) {
      return console.log(error);
    });
  }, []);

  var handleMenuChange = function handleMenuChange(index) {
    setMenuIndex(index);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PromptPortal, {
    shouldShow: isOpen
  }, /*#__PURE__*/React.createElement(StyledModal, {
    isOpen: isOpen,
    onRequestClose: handleClose,
    closeButton: {
      position: CloseButtonPosition.upperRight,
      size: 10
    }
  }, /*#__PURE__*/React.createElement(DeveloperMenuSelector, {
    handleMenuChange: handleMenuChange
  }), developerMenuItems[menuIndex] === 'BUILD_SELECTOR' && /*#__PURE__*/React.createElement(OptionsContainer, null, buildOptions.map(function (buildOption) {
    return /*#__PURE__*/React.createElement(BuildList, {
      key: "".concat(buildOption.projectName, "_builds"),
      customBuilds: customBuilds,
      initCustomBuilds: initCustomBuilds,
      buildOption: buildOption
    });
  })), developerMenuItems[menuIndex] === 'FEATURE_TOGGLE' && /*#__PURE__*/React.createElement(FeatureToggleList, {
    featureNames: sortedFeatureNames,
    handleEnvToggle: handleEnvToggle,
    optimizelyEnv: optimizelyEnv
  }))), !isOpen && /*#__PURE__*/React.createElement(SettingsButton, {
    onClick: handleOpen
  }, /*#__PURE__*/React.createElement(AcornsIcon, {
    icon: AcornsIcon.Icon.CogFilledWhite,
    width: "35px",
    height: "35px"
  }), customBuilds.length > 0 && /*#__PURE__*/React.createElement(AlertBadge, {
    title: "Currently selected MFE custom builds"
  }, customBuilds.length)));
};

export { BuildSelector };